import { createReducer, on } from '@ngrx/store';
import { cloneDeep } from 'lodash';

import { MapDataLayer } from '@core/api';
import { initActions, ItemUIState } from '@core/store';

import { initMapSuccess } from '../actions/api/maps-api.actions';
import { dataLayersActions } from '../actions/data-layers.actions';
import * as mapPageActions from '../actions/map-page.actions';

export const featureKey = 'dataLayers';

export interface DataLayersState extends Omit<ItemUIState<MapDataLayer[]>, 'status'> {
  status: 'INIT' | 'LOADING' | 'REFRESHING' | 'READY' | 'ERROR';
}
export interface DataLayersState {
  dataLayers: MapDataLayer[];
}

export const initialState: DataLayersState = {
  status: 'INIT',
  dataLayers: [],
};

export const reducer = createReducer<DataLayersState>(
  cloneDeep(initialState),
  on(initActions.appCleanup, mapPageActions.leaveMap, () => cloneDeep(initialState)),
  on(
    initMapSuccess,
    dataLayersActions.fetchDataLayers,
    dataLayersActions.showDataLayer,
    dataLayersActions.hideDataLayer,
    dataLayersActions.updateDataLayerOpacity,
    dataLayersActions.addLayerToFavourites,
    dataLayersActions.removeLayerFromFavourites,
    (state) => ({
      ...state,
      status: state.dataLayers.length > 0 ? 'REFRESHING' : 'LOADING',
    })
  ),
  on(dataLayersActions.fetchDataLayersSuccess, (state, { dataLayers }) => ({
    ...state,
    status: 'READY',
    dataLayers,
  })),
  on(dataLayersActions.fetchDataLayersFails, (state, { error }) => ({
    ...state,
    status: 'ERROR',
    error,
  })),
  on(
    dataLayersActions.showDataLayerFail,
    dataLayersActions.hideDataLayerFail,
    dataLayersActions.updateDataLayerOpacityFail,
    dataLayersActions.addLayerToFavouritesFail,
    dataLayersActions.removeLayerFromFavouritesFail,
    (state, { error }) => ({
      ...state,
      status: state.dataLayers.length > 0 ? 'READY' : 'ERROR',
      error,
    })
  )
);
